import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as me from '../../me'
import * as contexts from '../contexts'
import * as portalAccess from '../portal-access'

import { Api } from './api.service'
import * as effects from './effects'
import type { TypeParams } from './types'

/**
 * Provides a collection of tenants within the Admin portal
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Collection extends ec.Collection<TypeParams> {
  /** @see {@link router.Router} */
  private readonly _router = ngCore.inject(router.Router)
  constructor() {
    const _contexts = ngCore.inject(contexts.Feature)
    const _meFeature = ngCore.inject(me.Feature)
    super({
      api: ngCore.inject(Api),
      identify: tenant => tenant.id,
      name: ec.Name.Predefined.AdminTenant,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: ({ entity: tenant }) => ({
              iconsConfigs: portalAccess.ContentActionAccess.canDeleteTenant(
                _meFeature.selectors.currentUser.asSignal(),
              )
                ? [
                    {
                      class: 'atn-icon atn-trash atn-red',
                      onClick: () => {
                        collection.plugins.editingPlugin.feature.actions.markForDeletion
                          .from(`Table.Row-${tenant.id}.Icons.Trash.Clicked`)
                          .dispatch({ id: tenant.id })
                      },
                    },
                  ]
                : [],
              onClick: () => {
                const source = `Table.Row-${tenant.alias}.Clicked`

                const url = _contexts.selectors
                  .getUrlForTenant(tenant)
                  .asSignal()

                if (url) {
                  this._router.actions.navigate.from(source).dispatch({ url })
                }
              },
            }),
          })),
        ],
        currentList: {
          sortBy: { get: key => key ?? 'name' },
        },
      },
    })
    this.feature.registerEffects(
      effects.syncCurrentEntityWithUrl(this, this._router),
    )
  }
}
